<template>
  <div>
    <!-- Modal de confirmação antes de entrar na tela de descanso -->
    <transition name="idleFade">
      <div
        v-if="showConfirmation"
        class="idle-confirmation-overlay"
      >
        <div class="idle-confirmation-modal">
          <div class="modal-icon">
            <b-icon
              icon="clock-history"
              font-scale="3"
              variant="warning"
            />
          </div>
          <h2 class="modal-title">
            Você ainda está aí?
          </h2>
          <p class="modal-message">
            A sessão será finalizada em <strong>{{ countdown }}</strong> segundos
          </p>
          <button
            class="btn-continue"
            @click="onContinueSession"
          >
            Continuar comprando
          </button>
        </div>
      </div>
    </transition>

    <!-- Tela de descanso -->
    <transition name="idleFade">
      <atm-rest-screen v-if="showRestScreen" />
    </transition>
  </div>
</template>

<script>
import { BIcon } from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import AtmRestScreen from '../pages/pdv/atm/AtmRestScreen.vue'

const COUNTDOWN_SECONDS = 20

export default {
  components: {
    BIcon,
    AtmRestScreen,
  },

  data() {
    return {
      showConfirmation: false,
      showRestScreen: false,
      countdown: COUNTDOWN_SECONDS,
      countdownTimer: null,
    }
  },

  computed: {
    ...mapGetters('app/idle', ['isIdle']),
    ...mapGetters('pages/pdv/atm/status', ['hasPendingSaleToFinishInAtm']),

    isAtmHomeRoute() {
      return this.$route.name === 'pdv-atm'
    },
  },

  watch: {
    isIdle(newValue) {
      if (newValue) {
        this.onIdleTriggered()
      } else {
        this.resetState()
      }
    },
  },

  beforeDestroy() {
    this.clearCountdownTimer()
  },

  methods: {
    ...mapActions('app/idle', ['restartIdle']),

    onIdleTriggered() {
      // Não exibe a contagem regressiva nem a tela de descanso quando já existe
      // um pagamento registrado na venda. Nesse cenário (ex.: cliente na tela de
      // pagamento aguardando a seleção do estado do produto), o timer não deve
      // cancelar a venda automaticamente.
      if (this.hasPendingSaleToFinishInAtm) {
        this.resetState()
        return
      }

      // Se está na rota pdv-atm, mostra confirmação primeiro
      if (this.isAtmHomeRoute) {
        this.startConfirmationCountdown()
      } else {
        // Outras rotas vão direto para a tela de descanso
        this.showRestScreen = true
      }
    },

    startConfirmationCountdown() {
      this.showConfirmation = true
      this.countdown = COUNTDOWN_SECONDS

      this.countdownTimer = setInterval(() => {
        this.countdown -= 1

        if (this.countdown <= 0) {
          this.clearCountdownTimer()
          this.showConfirmation = false
          this.showRestScreen = true
        }
      }, 1000)
    },

    onContinueSession() {
      // Usuário quer continuar, reseta o idle
      this.restartIdle()
    },

    resetState() {
      this.clearCountdownTimer()
      this.showConfirmation = false
      this.showRestScreen = false
      this.countdown = COUNTDOWN_SECONDS
    },

    clearCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
  },
}
</script>

<style scoped lang="scss">
/* Fade transition */
.idleFade-enter-active,
.idleFade-leave-active {
  transition: opacity 0.5s ease;
}

.idleFade-enter,
.idleFade-leave-to {
  opacity: 0;
}

/* Modal de confirmação */
.idle-confirmation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.idle-confirmation-modal {
  background: white;
  border-radius: 20px;
  padding: 40px 60px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 450px;
  animation: modalPulse 2s ease-in-out infinite;
}

@keyframes modalPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.02);
  }
}

.modal-icon {
  margin-bottom: 20px;
  color: #f0ad4e;
}

.modal-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  font-family: 'Baloo2-Bold', 'Arial', sans-serif;
}

.modal-message {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
  font-family: 'Baloo2-Regular', 'Arial', sans-serif;

  strong {
    font-size: 24px;
    color: #e74c3c;
    font-weight: bold;
  }
}

.btn-continue {
  width: 100%;
  height: 60px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 30px;
  font-size: 20px;
  font-weight: bold;
  font-family: 'Baloo2-Bold', 'Arial', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #218838;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(40, 167, 69, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
}
</style>
